import * as _ from "lodash";
import * as angular from "angular";
import { CheckManager } from "../../shared/check-manager";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { Filter } from "../../models/filter.model";
import { Issue } from "../../models/issue.model";
import { PermissionCheck } from "../../shared/permission";
import { IssueService } from "../../services/issue.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { IssueDataProvider } from "../../data-provider/issue.dp";
import { Group } from "../../models/group.model";
import { SearchUtils } from "../../helper/search.helper";

let IssueListComponent = {
    selector: "vcIssueList",
    templateUrl: "/angular/components/issue/issue-list.component.html",
    bindings: {
        filter: "=",
        selectedIssue: "=",
    },
    controller: class IssueListController {
        // * bindings for typescript compiler *
        public filter: Filter;
        public selectedIssue: Issue;
        // ************************************

        private $scope: any;
        private $location: any;
        private $q: any;
        private __env: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;

        private resource: IssueService;
        private dataProvider: IssueDataProvider;
        private filterDataProvider: FilterDataProvider;
        private searchUtils: SearchUtils;
        public permissionProvider: PermissionCheck;

        public issues: Array<Issue>;
        public statuses: Array<any>;
        public checkManager: CheckManager;

        constructor(
            $scope: any,
            $location: any,
            $q: any,
            __env: any,
            DialogUtils: DialogUtils,
            IssueService: IssueService,
            IssueDataProvider: IssueDataProvider,
            FilterDataProvider: FilterDataProvider,
            PermissionCheck: PermissionCheck,
            SearchUtils: SearchUtils,
            ToastUtils: ToastUtils
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.resource = IssueService;
            this.dataProvider = IssueDataProvider;
            this.filterDataProvider = FilterDataProvider;
            this.permissionProvider = PermissionCheck;
            this.searchUtils = SearchUtils;
            this.$location = $location;
            this.toast = ToastUtils;
            this.$q = $q;
            this.__env = __env;
            this.filter = this.filterDataProvider.filter;
            this.dataProvider.infiniteItems.loading = true;
            this.checkManager = this.dataProvider.checkManager;
            this.checkManager.checkAll(false);
            this.dataProvider.setFilters(this.filter);

            this.dataProvider.getStatuses().then((statuses) => {
                this.statuses = statuses;
            });
        }

        $onInit() {
            if (this.filter.search && this.filter.search.values) {
                this.searchUtils.searchText = this.filter.search.values;
            }

            this.searchUtils.setSearchBar(
                "Search Follow-up requests",
                (search) => {
                    this.filter.search = search;
                    return this.$q.resolve([]); //Not using the results for the search dropdown so return empty.
                },
                null,
                true
            );

            this.$scope.$watch(
                () => this.filter,
                (newValue, oldValue) => {
                    if (
                        !this.issues ||
                        (newValue &&
                            !angular.equals(newValue, oldValue) &&
                            (angular.equals(newValue.csqid, oldValue.csqid) ||
                                newValue.status != oldValue.status))
                    ) {
                        //if it's the issue that has changed, it shouldn't get filtered issues
                        this.checkManager.checkAll(false);
                        this.dataProvider.setFilters(this.filter);
                        this.dataProvider.resetIssue();
                        this.$location.search(this.filter);
                    }
                },
                true
            );
        }

        getSelectedIssue(issue: Issue): void {
            this.$location.search("csqid", issue.csqid);
            this.dataProvider.getIssue(issue.csqid).then((returnedIssue) => {
                this.dataProvider.replaceIssue(returnedIssue);
            });
        }

        totalIssues(): number {
            let total = 0;
            for (let property in this.dataProvider.mailboxLabels) {
                total += this.dataProvider.mailboxLabels[property];
            }
            return total;
        }

        openDeleteIssueDialog(issue: Issue, ev: object): void {
            this.dialog
                .show({
                    component: "vc-issue-delete",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Delete follow-up request",
                    scope: this.$scope,
                    locals: {
                        selectedIssue: issue,
                    },
                })
                .then((issue) => {
                    this.dataProvider.deleteIssue(issue).then(() => {
                        this.toast.success("Follow-up request deleted");
                    });
                });
        }

        openBulkIssueStatusDialog(ev: object): void {
            this.dialog
                .show({
                    component: "vc-issue-status",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Change follow-up request Status",
                    scope: this.$scope,
                    locals: {
                        selectedIssue: {},
                    },
                })
                .then((issue) => {
                    let data = _.cloneDeep(this.checkManager);
                    data["new_status"] = issue.status.csqasid;
                    angular.extend(data, this.filter);

                    this.resource.bulk_status(data).then((response) => {
                        const json = response["data"];
                        if (json.success) {
                            this.toast.success(
                                "Status of " +
                                    this.checkManager.checked_items_count +
                                    " follow-up request changed to " +
                                    issue.status.csqasstatus
                            );
                            this.reloadData();
                            this.getSelectedIssue(this.selectedIssue);
                        }
                        this.checkManager.checkAll(false);
                    });
                });
        }

        reloadData(): void {
            this.dataProvider.setFilteredIssuesCount(undefined);
            this.dataProvider.infiniteItems.reset();
            this.dataProvider.resetFilteredIssues();
            this.checkManager.removeCheckedItems();
        }

        openBulkIssuePriorityDialog(ev: object): void {
            this.dialog
                .show({
                    component: "vc-issue-priority",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Change follow-up request Priority",
                    scope: this.$scope,
                    locals: {
                        selectedIssue: {},
                    },
                })
                .then((issue) => {
                    let data = _.cloneDeep(this.checkManager);
                    data["priority"] = issue.csqapriority;
                    angular.extend(data, this.filter);

                    this.resource.bulk_priority(data).then((response) => {
                        const json = response["data"];
                        if (json.success) {
                            this.reloadData();
                            this.getSelectedIssue(this.selectedIssue);
                            this.toast.success(
                                "Priority of " +
                                    this.checkManager.checked_items_count +
                                    " follow-up request changed to " +
                                    issue.csqapriority
                            );
                        }
                        this.checkManager.checkAll(false);
                    });
                });
        }

        openBulkIssueDeleteDialog(ev: object): void {
            this.dialog
                .show({
                    component: "vc-issue-delete",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Delete follow-up request",
                    scope: this.$scope,
                    locals: {
                        selectedIssue: {},
                    },
                })
                .then(() => {
                    let data = _.cloneDeep(this.checkManager);
                    angular.extend(data, this.filter);

                    this.resource.bulk_delete(data).then((response) => {
                        const json = response["data"];
                        if (json.success) {
                            this.toast.success(
                                this.checkManager.checked_items_count +
                                    " follow-up requests have been deleted."
                            );
                            this.reloadData();
                            this.getSelectedIssue(this.selectedIssue);
                        }
                        this.checkManager.checkAll(false);
                    });
                });
        }

        openBulkIssueGroupDialog(ev: object): void {
            this.dialog
                .show({
                    component: "vc-group-selection-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    locals: {
                        provider: null,
                    },
                })
                .then((group: Group) => {
                    let data = _.cloneDeep(this.checkManager);
                    angular.extend(data, this.filter);
                    data["group"] = group;

                    this.resource.addMembersFromFilter(data).then(
                        (response) => {
                            const json = response["data"];
                            if (json.success) {
                                this.toast.success(
                                    this.checkManager.checked_items_count +
                                        " " +
                                        this.__env.strings.voters +
                                        " have been added to the " +
                                        group.gname +
                                        " list."
                                );
                            }
                            this.checkManager.checkAll(false);
                        },
                        () => {
                            this.toast.error();
                        }
                    );
                });
        }

        openBulkIssueAssignDialog(ev: object): void {
            this.dialog
                .show({
                    component: "vc-issue-assign",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Change User Assigned to this follow-up request",
                    size: "small",
                    scope: this.$scope,
                    locals: {
                        selectedIssue: {},
                    },
                })
                .then((issue) => {
                    let data = _.cloneDeep(this.checkManager);
                    data["assigned_uid"] = issue.assigned.uid;
                    angular.extend(data, this.filter);

                    this.resource.bulk_assign(data).then((response) => {
                        const json = response["data"];
                        if (json.success) {
                            this.toast.success(
                                this.checkManager.checked_items_count +
                                    " follow-up requests assigned to " +
                                    issue.assigned.ufname +
                                    " " +
                                    issue.assigned.ulname
                            );

                            if (
                                angular.isDefined(this.filter.assigned) &&
                                this.filter.assigned
                            ) {
                                this.reloadData();
                            } else if (json.mailbox_counts) {
                                this.getSelectedIssue(this.selectedIssue);
                                this.dataProvider.setMailboxLabels(
                                    json.mailbox_counts
                                );
                            } else {
                                this.getSelectedIssue(this.selectedIssue);
                            }
                        }
                        this.checkManager.checkAll(false);
                    });
                });
        }
    },
};

angular
    .module("issue", ["vcServices"])
    .component(IssueListComponent.selector, IssueListComponent);
